import React from "react";
import "./ActivityRecordsListScroller.css";

/**
 * Scrollable viewport for activity cards (native vertical scrollbar, styled).
 * @param {{ children: React.ReactNode }} props
 */
export default function ActivityRecordsListScroller({ children }) {
  return (
    <div className="activity-records-scroller">
      <div
        className="activity-records-scroller__viewport"
        data-testid="activity-records-viewport"
      >
        {children}
      </div>
    </div>
  );
}
